import { Injectable } from "@angular/core";
import { ColumnPreference, SelectedColumnPreferences } from "../../models/column-preference";
import { UserPreferencesService } from "../user-preferences/user-preferences.service";
import { UserPreferenceEnum } from "src/app/modules/setting/setting/setting.component";
import { DataRepositoryService } from "../data-repository/data-repository.service";
import { SelectedPreferencesENUM } from "../../models/preference";
import { takeLast } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class ColumnService {
  constructor(
    private readonly userPreferenceServcie: UserPreferencesService,
    private readonly dataRepositoryService: DataRepositoryService
  ) { }

  /**
   * 
   * @param table 
   * @param columnPreference 
   */
  setUserColumnPreference(table: string, columnPreference: ColumnPreference, tempUpdate:boolean) {
    try {
       if(columnPreference && table) {
        // Create a deep copy to avoid reference issues
        const columnPreferenceCopy: ColumnPreference = {
          ...columnPreference,
          columnList: columnPreference.columnList.map(col => ({...col}))
        };
        
        const currentTempPrefs = this.dataRepositoryService.tempSelectedUserColumnPreferences();
        const newTempPrefs: SelectedColumnPreferences = currentTempPrefs ? { ...currentTempPrefs } : {};
        newTempPrefs[table] = columnPreferenceCopy;
        this.dataRepositoryService.tempSelectedUserColumnPreferences.set({ ...newTempPrefs })
        if(!tempUpdate) {
          const currentPrefs = this.dataRepositoryService.selectedUserColumnPreferences();
          const newPrefs: SelectedColumnPreferences = currentPrefs ? { ...currentPrefs } : {};
          newPrefs[table] = {
            ...columnPreferenceCopy,
            columnList: columnPreferenceCopy.columnList.map(col => ({...col}))
          };
          this.dataRepositoryService.selectedUserColumnPreferences.set({...newPrefs});
          this.saveUserPreference(this.dataRepositoryService?.selectedUserColumnPreferences()??{} as SelectedColumnPreferences);
        }
       }
    } catch (error) {}
  }

  /**
   * Save user preferences to backend
   * @param preferences 
   */
  saveUserPreference(preferences: SelectedColumnPreferences) {
    if(preferences) {
      this.userPreferenceServcie.saveUserPreference(UserPreferenceEnum.SELECTEDUSERPREFERENCES, preferences, false).subscribe({
        next:(response:any) => {
        },
        error: (error:any) => {
        }
      })
    }
  }

  /**
   * Get selected user column preferences from backend
   */
  getSelectedUserColumnPreference() {
    this.userPreferenceServcie
      .getUserPreferenceByKey(UserPreferenceEnum.SELECTEDUSERPREFERENCES).pipe(takeLast(1))
      .subscribe({
        next: (response: any) => {
          if(response?.preferenceValue !== null) {
            const selectedUserPreference = response?.preferenceValue ? JSON.parse(response.preferenceValue) : null;
            const tempUserPreference = response?.preferenceValue ? JSON.parse(response.preferenceValue) : null;
            this.dataRepositoryService.selectedUserColumnPreferences.update(()=>selectedUserPreference)
            this.dataRepositoryService.tempSelectedUserColumnPreferences.update(()=>tempUserPreference)
          }else {
            this.dataRepositoryService.selectedUserColumnPreferences.set(null)
            this.dataRepositoryService.tempSelectedUserColumnPreferences.set(null)
          }
        },
        error: (err: any) => {
         this.dataRepositoryService.selectedUserColumnPreferences.set(null)
         this.dataRepositoryService.tempSelectedUserColumnPreferences.set(null)
        },
      });
  }
}
